import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { STD_BASE_HP } from "../physicalThingWithHp";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class LargeMachine extends DestroyableObstacle {
	static key = "LargeMachine";
	constructor(xy: XY) {
		super(xy);
		this.hp = STD_BASE_HP * 2;
		this.maxHp = STD_BASE_HP * 2;
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.METAL_DEBRIS;
	}

	static deserialize(data: any): LargeMachine {
		const m = new LargeMachine(deserializeXY(data.xy));
		m.restoreBaseFields(data);
		return m;
	}
}
